// extracted by mini-css-extract-plugin
export var container = "_cs-0";
export var icon = "_cs-1";
export var text = "_cs-2";